<template>
    <a-config-provider :locale="locale" v-if="show">
        <div id="app">
            <keep-alive>
                <router-view v-if="$route.meta.keepAlive" />
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive" />
        </div>
        <div id="map" style="width: 0; height: 0;"></div>
    </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN';
export default {
    name: 'App',
    data() {
        return {
            locale: zhCN,
            show: true
        }
    },
    methods: {}
}
</script>

<style lang="less">
@import './styles/default.less';

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 14px;
    color: @gray-color;
    // height: 100%;
    min-width: 1400px;
    background: @default-color;
}

body {
    height: 100%;
}
</style>
